import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_CLONE_COLLECTION_BEGIN,
  COLLECTIONS_CLONE_COLLECTION_SUCCESS,
  COLLECTIONS_CLONE_COLLECTION_FAILURE,
  COLLECTIONS_CLONE_COLLECTION_DISMISS_ERROR,
} from './constants';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function cloneCollection(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_CLONE_COLLECTION_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/clone-collection`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_CLONE_COLLECTION_SUCCESS,
            data: res,
          });
          toast.success('Collection Cloned Successfully !');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_CLONE_COLLECTION_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}` || 'Clone Failed !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCloneCollectionError() {
  return {
    type: COLLECTIONS_CLONE_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CLONE_COLLECTION_BEGIN:
      return {
        ...state,
        cloneCollectionPending: true,
        cloneCollectionError: null,
      };

    case COLLECTIONS_CLONE_COLLECTION_SUCCESS:
      return {
        ...state,
        cloneCollectionPending: false,
        cloneCollectionError: null,
      };

    case COLLECTIONS_CLONE_COLLECTION_FAILURE:
      return {
        ...state,
        cloneCollectionPending: false,
        cloneCollectionError: action.data.error,
      };

    case COLLECTIONS_CLONE_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        cloneCollectionError: null,
      };

    default:
      return state;
  }
}
